import { render, staticRenderFns } from "./BudgetBatchShow.vue?vue&type=template&id=2501c008"
import script from "./BudgetBatchShow.vue?vue&type=script&lang=ts"
export * from "./BudgetBatchShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports